var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard6A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "frame_730px_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "beard_x5F_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31__1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M359.9,375.5c-1.4,0-12,0.7-8.5,3.7c1.6,1.4,3.4,2.3,4.9,3.9c0.8,0.8,1.4,1.8,2,2.7 c0.5,0.8,0.2,2.4,1.1,2.7c1.3,0.5,2.9-3.7,3.7-4.8c1.3-1.8,2.7-3,4.2-4.4c2.3-2.1,0.4-2.4-1.7-3 C363.8,375.9,361.9,375.6,359.9,375.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M304.5,351.1c1.3,0.2,4.5-1.4,5.7-1.7c2.3-0.8,4.8-1.4,7.2-2c9.2-2.4,17.9-3.6,27.4-2.7 c5.3,0.5,10.5,2.7,16,2.5c5.5,0.2,10.6-2,16-2.5c9.5-0.9,18.3,0.3,27.4,2.7c2.4,0.6,4.8,1.2,7.1,2c1.1,0.4,4.4,1.9,5.7,1.7 c1.4-0.2-2.4-7-5.6-8.5c-8.2-4-18.6-4-27-5.8c-2-0.4-4.3-1.1-6.1-2c-2.4-1.2-2.6-1.3-5-0.3c-4.2,1.8-7.9,2.9-12.6,3 c-4.7-0.2-8.4-1.2-12.6-3c-2.4-1.1-2.6-1-5,0.3c-1.8,0.9-4.1,1.6-6.1,2c-8.3,1.8-18.7,1.8-27,5.8 C306.9,344.2,303.1,351,304.5,351.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M454.7,267.5c-5.6,17.8-5.6,34.8-15,54c-2.4,6.1-6.6,10.5-11.2,15.2c-2.4,4.1-5,9.5-6.3,14.1 c-2.7,9.6-9.4,15.2-17,20.7c-14.4,10.6-27.7,22-45.4,23.1c-0.5,0-1,0-1.4,0c-0.1,0-0.3,0-0.5,0c-18.6-0.2-31.4-12.5-46-23.2 c-7.6-5.6-14.3-11.1-17-20.7c-1.3-4.6-3.9-10-6.3-14.1c-4.6-4.7-8.8-9-11.2-15.2c-9.4-19.2-11.9-37.2-17.5-55.1 c-1.2,11.7,1.4,18.5,2.1,31.7c0.2,3.2,2.7,18.5,3,20.9c2.9,13.8,4.1,16.5,9.2,29.2c2.5,6.1,7,11.6,10.7,16.9s7,9.2,12.1,15.2 c4.6,4,7.7,7.7,12.3,11.7c5.5,4.8,8.7,7.1,13.6,10.8c9.5,7.3,22.8,12.3,34.6,12.9c0.1,0,0.5,0,0.8,0l0,0c0.1,0,0.2,0,0.3,0 c0.1,0,0.2,0,0.3,0l0,0c0.3,0,0.7,0,0.8,0c11.7-0.6,23.5-5.4,32.9-12.8c4.8-3.8,10.7-8.5,15.5-12.2c4.9-3.7,7.7-7.1,12.3-11.2 c5.3-4.1,9.7-8.9,13.3-14.2c3.7-5.3,6.6-11.1,9.1-17.2c5.1-12.8,6.2-17.3,9.1-31.1c0.3-2.5,2-15.1,2.1-17.6 C454.7,286.3,457.6,279.2,454.7,267.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard6A);
export default __webpack_public_path__ + "static/media/man_beard_6a.02539b7d90f3ab623e8170d66b8c86fb.svg";
export { ForwardRef as ReactComponent };